// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c548dc11","455":"857ca85b","977":"ec578cd0"}[chunkId] + ".chunk.js";
};